import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  alert: undefined,
};

export const showAlert = createAction("alerts/showAlert");

export const hideAlert = createAction("alerts/hideAlert");

export const alertSlice = createSlice({
  name: "alert",
  initialState,
  extraReducers: {
    [showAlert]: (state, action) => {
      state.alert = action.payload;
    },
    [hideAlert]: (state) => {
      state.alert = undefined;
    },
  },
});

export default alertSlice.reducer;
